import { IParkingLocationEntry } from '../../../../contentful/types/IParkingLocationEntry';
import { IParkingAvailability } from '../models/IParkingAvailability';

export interface IDisplayedParking {
	parking: IParkingAvailability;
	override: boolean;
}

export function applyContentfulOverrides(
	apiParkings: IParkingAvailability[],
	contentfulParkingLocations?: IParkingLocationEntry[],
): IDisplayedParking[] {
	if (!contentfulParkingLocations?.length) {
		return apiParkings.map((parking) => ({ parking, override: false }));
	}

	return apiParkings.map((parking) => {
		const contentfulMatch = contentfulParkingLocations.find(
			(entry) => entry.fields.id === parking.id,
		);

		if (contentfulMatch?.fields.override) {
			return {
				parking: {
					...parking,
					status: contentfulMatch.fields.status ?? null,
				},
				override: true,
			};
		}

		return { parking, override: false };
	});
}
